import dayjs, { type Dayjs } from "dayjs";

export const FREIGHT_DATE_RANGE_DAYS = 1095;

export function getFreightDateBounds(): { minDate: Dayjs; maxDate: Dayjs } {
    const maxDate = dayjs().startOf("day");
    const minDate = maxDate.subtract(FREIGHT_DATE_RANGE_DAYS, "day");

    return { minDate, maxDate };
}

export function getFreightDefaultDateRange(): { dateFrom: Dayjs; dateUntil: Dayjs } {
    const { minDate, maxDate } = getFreightDateBounds();

    return {
        dateFrom: minDate,
        dateUntil: maxDate,
    };
}

export function isFreightDateOutOfRange(current?: Dayjs): boolean {
    if (!current) {
        return false;
    }

    const { minDate, maxDate } = getFreightDateBounds();
    const normalizedDate = current.startOf("day");

    return normalizedDate.isBefore(minDate) || normalizedDate.isAfter(maxDate);
}